import { Navigate } from 'react-router-dom';
import { useAuth } from '../providers/AuthProvider';

export function Logout() {
  const { logout } = useAuth();
  logout();
  return <Navigate to="/" />;
}
